import * as ArcIn from './ArcIn';
import * as BlurIn from './BlurIn';
import * as ShuttersIn from './ShuttersIn';
import * as BounceIn from './BounceIn';
import * as CurveIn from './CurveIn';
import * as CircleIn from './CircleIn';
import * as DropIn from './DropIn';
import * as ExpandIn from './ExpandIn';
import * as FadeIn from './FadeIn';
import * as FlipIn from './FlipIn';
import * as FloatIn from './FloatIn';
import * as FoldIn from './FoldIn';
import * as GlideIn from './GlideIn';
import * as GlitchIn from './GlitchIn';
import * as GrowIn from './GrowIn';
import * as PunchIn from './PunchIn';
import * as ShapeIn from './ShapeIn';
import * as RevealIn from './RevealIn';
import * as SlideIn from './SlideIn';
import * as SpinIn from './SpinIn';
import * as TiltIn from './TiltIn';
import * as TurnIn from './TurnIn';
import * as WinkIn from './WinkIn';
export const entranceAnimations = {
  ArcIn,
  BlurIn,
  ShuttersIn,
  BounceIn,
  CurveIn,
  CircleIn,
  DropIn,
  ExpandIn,
  FadeIn,
  FlipIn,
  FloatIn,
  FoldIn,
  GlideIn,
  GlitchIn,
  GrowIn,
  PunchIn,
  ShapeIn,
  RevealIn,
  SlideIn,
  SpinIn,
  TiltIn,
  TurnIn,
  WinkIn
};
//# sourceMappingURL=index.js.map